/**
 * Farmer-facing labels for stored values whose canonical string is legacy or
 * reads badly on its own. Lives in shared/ so the profile UI and the hide-reason
 * texts (deriveReason / describeRule) name a certification the same way.
 */

/** Stored certification value → display label. Values not listed display as-is. */
export const CERT_DISPLAY_LABELS: Record<string, string> = {
  'IP Sigill': 'IP-standarden (Sigill)',
  'IP Sigillnivå': 'IP Sigillnivå (Svenskt Sigill)',
};

/** Farmer-facing label for a certification value. */
export const certLabel = (value: string): string => CERT_DISPLAY_LABELS[value] ?? value;

/**
 * Display form of a condition value for the given field — only certifications
 * have aliases today; every other field shows the stored string.
 */
export function displayConditionValue(field: string, value: string): string {
  return field === 'certifications' ? certLabel(value) : value;
}
